<template>
    <div
        v-if="modelValue"
        class="form-infotext flex-fill"
    >
        <span>{{ $tm(value, '', true) }}</span>
    </div>
</template>
<script setup lang="ts">
/**
 * Since we are handling the infotext as a component we need to have the correct signature
 * with props and exposes.
 * Modelvalue will contain the separator string = translation key
 */

const value = defineModel<string>({ required: true });

defineExpose({ focus: () => {} });
</script>
